<template>
  <div class="login-nav">
    <div class="login-nav_logo">
      <img :src="logoUrl" class="click-cursor" height="100%" @click="handleHrefOwlCloud" />
    </div>
    <div class="login-nav_btn">
      <span @click="handleHrefOwlCloud" class="owl-cloud">{{
        $t("common.OwlCloud")
      }}</span>
      <LanguageDropdown />
    </div>
  </div>
</template>

<script>
import logoZH from "@/assets/img/logo-04@2x.png";
import logoEN from "@/assets/img/logo-en-04@2x.png";
import LanguageDropdown from "@/components/LanguageDropdown";
import { computed } from "vue";
import { useStore } from "@whitekite/vue-helper";
export default {
  name: "LoginNavBar",
  components: { LanguageDropdown },
  setup: () => {
    const store = useStore();

    const handleHrefOwlCloud = () => {
      window.location.href = process.env.VUE_APP_BASE_OWL_COULD_URL
    };

    const logoUrl = computed(() => {
      return store.state.language === "zh" ? logoZH : logoEN;
    });

    return {
      handleHrefOwlCloud,
      logoUrl,
    };
  },
};
</script>

<style scoped lang="scss">
.login-nav {
  width: 100%;
  @include flex-box(flex-start, center);
  background-color: rgba(0, 0, 0, 0.3);
  height: 62px;

  &_logo {
    flex: 1;
    padding-left: 40px;
    height: 48px;
  }

  &_btn {
    font-size: 16px;
    color: #ffffff;
    font-weight: $font-weight-5;
    padding-right: 40px;

    .owl-cloud {
      margin-right: 52px;
      @extend .click-cursor;
    }
  }
}

::v-deep(.el-dropdown) {
  @extend .login-nav_btn;
}
</style>
